import BatchBaseController from '../common/batch.base.controller'
import AppConstants from '../../../config/app.constants'

class BatchCreateController extends BatchBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, BatchService, Modal, $translate, CustomerService, LocationService) {

		super(Auth, $state, User, BatchService, Modal, $translate)
		this.CustomerService = CustomerService
		this.LocationService = LocationService
		this.locationsToIgnore;
		this.offset = 0;
		this.changeOffsetFlag = false;
		this.inputTypes = [
			'UUU',
			'UVV',
			'VVV',
			'ULV',
			'UHV',
			'VUV'
		]
		this.DEFAULT_INPUT_TYPE = 'VVV'
		this.locations = [];
		this.currentBranch = User.getUser().branchId;
	}
	$onInit() {
		this.onLoad()
	}

	onLoad = () => {
		this.model = {
			inputType: null,
			batchSourceId: null,
			description: ''
		};

		// fetch exisitning batches and remove their cooresponding location from locations dropdown
		this.Service.all(null, 0, 100)
			.then((batches) => {
				return batches.results.map((batch) => batch.batchSourceId)
			})
			.then((locationsToIgnore) => {
				this.locationsToIgnore = locationsToIgnore;
				this.getAllLocation('', 0);
			})
	}

	locationSearchObj = (searchKey) => {
		searchKey = searchKey || '';

		const searchObj = {
			queryJSON: {
				rules: [{
						field: 'branchId',
						condition: '=',
						data: this.User.getUser().branchId
					},
					{
						group: {
							rules: [{
									field: 'locationType',
									condition: '=',
									data: 'INTERNAL'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'BANK'
								}
							],
							operator: 'OR',
						}
					},
					{
						group: {
							rules: [{
									field: 'id',
									condition: 'like',
									data: '%' + searchKey + '%'
								},
								{
									field: 'name',
									condition: 'like',
									data: '%' + searchKey + '%'
								}
							],
							operator: 'OR'
						}
					}
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
	}

	mappingLocationDatas(locations) {
		return locations.map((location) => {
			location.Key = location.id + " | " + location.name;
			location.Value = location.id;
			return location;
		});
	}

	getAllLocation(searchKey, offset) {
		var locationSearchObj = this.locationSearchObj(searchKey);
		if (searchKey) {
			this.offset = 0;
		}
		else {
			if (offset == 0) {
				this.offset = 0;
			}
		}
		this.LocationService.getAllLocation(locationSearchObj, this.offset, AppConstants.defaultPageLimit)
			.then((res) => {
				if (this.offset === 0) {
					this.totalLocationRecords = res.total;
					this.locations = this.mappingLocationDatas(res.results).filter((location) => !this.locationsToIgnore.includes(location.id));
					this.offset += 10;
					if (this.locations.length <= 10 && !searchKey) {
						this.changeOffsetFlag = false;
						this.getAllLocation('', this.offset)
					}
				}
				else {
					const locations = this.mappingLocationDatas(res.results).filter((location) => !this.locationsToIgnore.includes(location.id));
					this.locations = this.locations.concat(locations);
					this.offset += 10;
					if (this.locations.length <= 10) {
						this.changeOffsetFlag = false;
						if (this.totalLocationRecords > this.offset) {
							this.getAllLocation('', this.offset)
						}
					} else this.changeOffsetFlag = true;
				}
			})
	}

	submit(evt) {
		this.loading = true
		this.model.batchSourceId = this.model.batchSourceId.id;
		this.Service.create(this.model, this.currentBranch)
			.then((res) => {
				this.askCreate()
			})
			.finally(() => {
				this.loading = false;
				this.onLoad()
			})

	}
	reset() {
		this.model = {
			inputType: null,
			batchSourceId: null,
			description: ''
		};
		this.clearErrors()
		// this.getAllLocation('', 0);
	}
}

export default BatchCreateController;


// WEBPACK FOOTER //
// ./client/app/components/batch/create/batch.create.controller.js